(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Alternate-product-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeEnquiries = (root) => {
    root.querySelectorAll('.alt-product-form').forEach((container) => {
      if (container.dataset.variantPickerInitialized) return;
      container.dataset.variantPickerInitialized = 'true';
      const variants = JSON.parse(container.querySelector('[data-alt-product-variants]').textContent);
      const selectors = Array.from(container.querySelectorAll('.variant-option'));
      const enquiry = container.querySelector('[data-whatsapp-enquiry]');
      const price = container.querySelector('.alt-prod-price');
      const initialVariantId = new URL(enquiry.dataset.productUrl, window.location.origin);
      const initialMessage = new URL(enquiry.href).searchParams.get('text');
      const initialMatch = initialMessage.match(/variant (\d+)/);

      const updateVariant = () => {
        const selectedOptions = selectors.map((select) => select.value);
        const variant = selectors.length
          ? variants.find((item) => item.options.length === selectedOptions.length && item.options.every((option, index) => option === selectedOptions[index]))
          : variants.find((item) => String(item.id) === initialMatch?.[1]);
        const url = new URL(initialVariantId.href);
        let message = `Hello ANDAL, I would like to enquire about ${enquiry.dataset.productTitle}`;
        if (variant) {
          if (enquiry.dataset.defaultVariant !== 'true') message += ` — ${variant.title}`;
          message += ` (variant ${variant.id})`;
          url.searchParams.set('variant', variant.id);
        } else if (selectedOptions.length) {
          message += ` — selected options: ${selectedOptions.join(' / ')}`;
        }
        enquiry.href = `https://wa.me/919550007619?text=${encodeURIComponent(`${message}. ${url.href}`)}`;
        price.textContent = variant ? variant.price : '';
        price.hidden = !variant || variant.price_amount <= 0;
      };

      selectors.forEach((select) => select.addEventListener('change', updateVariant));
      updateVariant();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeEnquiries(document), { once: true });
  } else {
    initializeEnquiries(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeEnquiries(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
